import { UMB_BOOLEAN_VALUE_SUMMARY_ALIAS } from './constants.js';
import { UmbBooleanValueSummaryElement } from './boolean-value-summary.element.js';
import { UMB_BOOLEAN_VALUE_TYPE } from '@umbraco-cms/backoffice/value-type';

export const manifests: Array<UmbExtensionManifest> = [
	{
		type: 'valueSummary',
		kind: 'default',
		alias: UMB_BOOLEAN_VALUE_SUMMARY_ALIAS,
		name: 'Boolean Value Summary',
		forValueType: UMB_BOOLEAN_VALUE_TYPE,
		element: UmbBooleanValueSummaryElement,
	},
];
